import {createNotificationComponent, Notification} from '@vfde-brix/notification';
import {NO_PATTERN_BUSINESS_LOGIC} from '@vfde-brix/core';

/**
 * mountNotification
 * @param notificationContainerId
 */
export const mountNotification = (notificationContainerId: string): Notification | null => {
    const container = document.getElementById(notificationContainerId);

    return container && createNotificationComponent(container, NO_PATTERN_BUSINESS_LOGIC);
};
